import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const LOGO = process.env.PUBLIC_URL + '/images/company-logo.png';

/**
 * Navigation items.
 * Items with `scroll` are smooth-scroll anchors on the home page.
 * Items with `to` are router links to other pages.
 */
const navItems = [
  { id: 'hero', label: 'Home', scroll: true },
  { id: 'services', label: 'Services', scroll: true },
  { id: 'about', label: 'About', scroll: true },
  { id: 'showcase', label: 'Showcase', scroll: true },
  { id: 'projects', label: 'Projects', to: '/projects' },
  { id: 'contact', label: 'Contact', scroll: true },
];

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile nav on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const handleScrollNav = (sectionId) => {
    // If the target element exists on the current page, scroll to it directly
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setMobileOpen(false);
      return;
    }

    // Otherwise navigate home first, then scroll after page loads
    navigate('/');
    setTimeout(() => {
      const target = document.getElementById(sectionId);
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    }, 100);
    setMobileOpen(false);
  };

  return (
    <header
      className={`site-header ${scrolled || !isHome ? 'scrolled' : 'over-hero'}`}
    >
      <div className="header-inner">
        <Link
          to="/"
          className="logo-link"
          aria-label="Emerald Horizon Home"
        >
          <img src={LOGO} alt="Emerald Horizon logo" className="header-logo" />
          <span className="header-brand-name">Emerald Horizon</span>
        </Link>

        <button
          type="button"
          className="nav-toggle"
          aria-label="Toggle menu"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`main-nav ${mobileOpen ? 'open' : ''}`} aria-label="Main navigation">
          {navItems.map((item) =>
            item.to ? (
              <Link
                key={item.id}
                to={item.to}
                className={`nav-link ${
                  location.pathname === item.to ? 'nav-link-active' : ''
                }`}
              >
                {item.label}
              </Link>
            ) : (
              <button
                key={item.id}
                type="button"
                className="nav-link"
                onClick={() => handleScrollNav(item.id)}
              >
                {item.label}
              </button>
            )
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
